import { Card, Typography, CardContent, Button } from "@mui/material";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Loader from "../../Loader/Loader";
import { useNavigate } from "react-router-dom";

const TaxInsights = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleViewBlog = (id, data) => {
    navigate(`/blog/${id}`, {
      replace: true,
      state: { data },
    });
  };

  const fetchBlog = async () => {
    setLoading(true);
    const url = "https://rohan-tax-services.onrender.com/api/auth/fetchblog";

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      var result = await response.json();

      if (response.ok) {
        result = result.reverse().slice(0, 3);
        console.log(result);
        setData(result);
        sessionStorage.setItem("RohanTaxServices", JSON.stringify(result));
      } else {
        toast.error(result.msg);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("RohanTaxServices");
    if (storedData) {
      setData(JSON.parse(storedData));
    } else {
      fetchBlog();
    }
  }, []);

  return (
    <>
      {loading ? (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <Loader />
        </div>
      ) : (
        <section className="py-20 px-5 md:py-20 bg-gray-50">
          <div className="container mx-auto max-w-7xl">
            <div className="text-center pb-6">
              <h2 className="text-3xl font-bold">
                Latest{" "}
                <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
                  Tax Update's
                </span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 !mt-6">
              {data.map((item, index) => (
                <Card
                  key={index}
                  className="h-full overflow-hidden transition-all duration-300 hover:shadow-xl flex flex-col"
                >
                  {/* Image Section */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={item.image}
                      alt="Rohan's Tax Services"
                      width={400}
                      height={200}
                      className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>

                  {/* Card Content Section */}
                  <CardContent className="flex flex-col justify-between p-4">
                    <Typography
                      variant="h6"
                      className="text-lg font-semibold text-gray-900 mb-2 line-clamp-1"
                    >
                      {item.title}
                    </Typography>
                    <Typography className="text-sm text-gray-600 line-clamp-2">
                      {item.description}
                    </Typography>

                    {/* Button Section */}
                    <div className="mt-4 flex justify-end">
                      <Button
                        variant="outlined"
                        sx={{
                          width: "150px",
                          color: "#151C62",
                          borderColor: "#151C62",
                        }}
                        onClick={() => handleViewBlog(item._id, data)}
                      >
                        View Blog
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default TaxInsights;
